import { 
  User, 
  Settings, 
  Bell, 
  Camera, 
  Users, 
  Handshake, 
  Building2, 
  Calendar,
  Activity,
  Package,
  UserPlus,
  Zap,
  CreditCard,
  Building,
  Map,
  Images,
  FileText,
  Mail,
  TrendingUp
} from "lucide-react";
import { PageHeaderProps } from "@/components/ui/page-header";

export const PAGE_HEADERS: Record<string, Omit<PageHeaderProps, "actions">> = {
  // User-facing pages
  profile: {
    title: "Profile Settings",
    description: "Manage your personal information and preferences",
    icon: User
  },
  
  documentation: {
    title: "Help & Documentation",
    description: "Complete guide to using the Snapshot Live Web Portal",
    icon: FileText
  },
  
  dashboard: {
    title: "Dashboard",
    description: "Overview of your devices and system status",
    icon: Activity
  },
  
  userNotifications: {
    title: "Notifications",
    description: "Stay updated with the latest alerts and messages",
    icon: Bell,
    iconBgColor: "bg-yellow-600",
    gradient: "from-header-yellow to-header-yellow"
  },
  
  userDeviceDetails: {
    title: "Device Details",
    description: "Monitor and manage your camera device",
    icon: Camera,
    iconBgColor: "bg-purple-600",
    gradient: "from-header-purple to-header-purple"
  },
  
  deviceAssignments: {
    title: "Device Assignments",
    description: "Manage device assignments and allocations",
    icon: Package
  },
  
  partnerPortal: {
    title: "Partner Dashboard",
    description: "View your performance metrics and key statistics",
    icon: Handshake
  },
  
  partnerOrders: {
    title: "Partner Orders",
    description: "View orders related to your deals and track their status",
    icon: Package
  },
  
  partnerResources: {
    title: "Partner Resources",
    description: "Download documents and resources available to you",
    icon: FileText
  },
  
  invite: {
    title: "Team Invitations",
    description: "Invite team members to collaborate",
    icon: UserPlus,
    iconBgColor: "bg-pink-600",
    gradient: "from-header-pink to-header-pink"
  },
  
  // CRM pages (matching existing pattern)
  crmContacts: {
    title: "Contact Management",
    description: "Manage your customer contacts and relationships",
    icon: Users
  },
  
  crmDeals: {
    title: "Opportunities Pipeline",
    description: "Create opportunities and track their progress through the sales pipeline",
    icon: Handshake
  },
  
  crmCompanies: {
    title: "Organisations",
    description: "Manage your business relationships and organisations",
    icon: Building2
  },
  
  crmActivities: {
    title: "Activities",
    description: "Track and manage customer interactions",
    icon: Calendar
  },
  
  crmOrders: {
    title: "Order Management",
    description: "Track and fulfill customer orders",
    icon: Package
  },
  
  crmPartners: {
    title: "Partner Management",
    description: "Manage your business partnerships",
    icon: Handshake
  },
  
  crmStaff: {
    title: "Staff Management", 
    description: "Manage your team members and roles",
    icon: Users
  },

  crmKpi: {
    title: "Business KPIs",
    description: "Monitor business performance metrics and sales pipeline",
    icon: TrendingUp
  },

  crmPipeline: {
    title: "Pipeline",
    description: "Monthly pipeline view for stock, production, and sales targets",
    icon: Calendar
  },

  // Admin pages
  creditManagement: {
    title: "Credit Management",
    description: "Manage credit packages and allocations",
    icon: CreditCard
  },
  
  adminDeviceDetails: {
    title: "Device Details",
    description: "View and manage device information",
    icon: Camera
  },
  
  userRoles: {
    title: "User Roles",
    description: "Manage user roles and permissions",
    icon: Users
  },
  
  admin: {
    title: "User Management",
    description: "Manage your organisation's users, roles and contacts",
    icon: Users
  },

  
  adminNotifications: {
    title: "Notifications",
    description: "View your pending notifications",
    icon: Bell
  },
  
  organisationProfile: {
    title: "Organisation Profile",
    description: "Manage your organisation information",
    icon: Building
  },

  apiConfiguration: {
    title: "API Configuration",
    description: "Manage API tokens, endpoints, and integration credentials",
    icon: Zap
  },

  map: {
    title: "Map",
    description: "View device locations on an interactive map",
    icon: Map
  },

  gallery: {
    title: "Gallery",
    description: "View images from your devices",
    icon: Images
  },

  adminOrders: {
    title: "Order Management",
    description: "Track and manage organization orders with detailed progress timelines",
    icon: Package
  },

  design: {
    title: "Email Design",
    description: "Manage email and URL templates for customer communications",
    icon: Mail
  },

  marketingCalendar: {
    title: "Marketing & Events Calendar",
    description: "Plan and track marketing activities, releases, and events across the year",
    icon: Calendar
  }
};
